import React from 'react';
import PackageVariantClosedIcon from 'mdi-react/PackageVariantClosedIcon';
import PublishIcon from 'mdi-react/PublishIcon';
import ItemNavLink from 'domain/fuse/preferences/DynamicNavLink/ItemNavLink';

const Sidebar = ({
  isAllowedMenuItem,
  authorities,
  classes,
  toggleDrawer,
  currentPageTitle,
  setCurrentPageTitle,
  isSidebarItemActive,
  titleMapping,
  open,
}) => (
  <>
    {isAllowedMenuItem('BATCH', authorities)
      && (authorities.includes('ACCOUNT_ADMIN', 'AUTHENTICATED', 'OPERATOR')
        || authorities.includes('OPERATOR')) && (
        <ItemNavLink
          classes={classes}
          titleMapping={titleMapping}
          toggleDrawer={toggleDrawer}
          isSidebarItemActive={isSidebarItemActive}
          open={open}
          to="/shipment/create-order"
          itemKey="createShipments"
          iconComponent={(
            <div>
              <PackageVariantClosedIcon />
              <PublishIcon className={classes.smallIcon} size={16} />
            </div>
          )}
          groupTitle="shipping"
        />
    )}
    {isAllowedMenuItem('BATCH', authorities)
      && (authorities.includes('ACCOUNT_ADMIN', 'AUTHENTICATED', 'OPERATOR')
        || authorities.includes('OPERATOR')) && (
        <ItemNavLink
          classes={classes}
          titleMapping={titleMapping}
          toggleDrawer={toggleDrawer}
          isSidebarItemActive={isSidebarItemActive}
          open={open}
          to="/shipment/batch-orders"
          itemKey="batchShipments"
          iconComponent={(
            <div>
              <PackageVariantClosedIcon />
              <PublishIcon className={classes.smallIcon} size={16} />
            </div>
          )}
          groupTitle="shipping"
        />
    )}
  </>
);

export default Sidebar;
